import {
  ActionViewModel,
  ActionViewModelImplementation,
  durationInSecondsOrZero,
  Effector,
  secondsToDuration,
  uuidOrNewUuid,
} from "./ActionViewModel";
import { allEffectorsWithType, StartDelayInput } from "./utils";
import {
  QuickAction,
  SetEngineRpmToMax,
  SetEngineRpmToMin,
} from "protos/atk/activities";
import { RigEffectiveConfig } from "protos/atk/effective_config";
import { TFunction } from "i18next";
import DecreaseToMinIcon from "common/images/atk-actions/decrease-to-min.svg?react";
import IncreaseToMaxIcon from "common/images/atk-actions/increase-to-max.svg?react";
import React from "react";

class EngineRpmMaxViewModel extends ActionViewModel<EngineRpmMaxViewModel> {
  constructor(
    effector: Effector,
    startInStageIndex: number,
    startDelaySec: number,
    public actionId: string,
    public actionData: SetEngineRpmToMax
  ) {
    super(effector, true, startInStageIndex, startDelaySec);
  }

  override toQuickAction(_finalActionThisEffector: boolean): QuickAction {
    return {
      actionId: uuidOrNewUuid(this.actionId),
      startDelay: secondsToDuration(this.startDelaySec),
      setEngineRpmToMax: this.actionData,
      carryOverIntoWorkTask: false,
    };
  }

  override actionCardTitle(
    t: TFunction,
    _rigEffectiveConfig: RigEffectiveConfig,
    stageIndex: number,
    _finalActionThisEffector: boolean
  ): string | undefined {
    if (stageIndex === this.startInStageIndex) {
      return t(
        "views.autotractor.autonomousActivities.action.cardTitle.engineMaxRpm"
      );
    }
  }

  override effectorBlockedByActionMessage(t: TFunction): string {
    return t(
      "views.autotractor.autonomousActivities.action.blockingMessage.engineMaxRpm"
    );
  }

  override components = engineRpmMax.components;
}
export const engineRpmMax: ActionViewModelImplementation<EngineRpmMaxViewModel> =
  {
    actionButtonLabelI18nKey:
      "views.autotractor.autonomousActivities.action.buttonLabel.engineMaxRpm",
    actionMenuSection: "holding-action",
    isNewActionAvailableForEffector: allEffectorsWithType("engine-rpm"),
    newAction: (_activationContext, startInStageIndex) => {
      return new EngineRpmMaxViewModel(
        { type: "engine-rpm" },
        startInStageIndex,
        0,
        "",
        {}
      );
    },
    fromQuickAction: (action, startInStageIndex) => {
      if (action.setEngineRpmToMax) {
        return new EngineRpmMaxViewModel(
          { type: "engine-rpm" },
          startInStageIndex,
          durationInSecondsOrZero(action.startDelay),
          action.actionId,
          action.setEngineRpmToMax
        );
      }
    },
    components: {
      Icon: IncreaseToMaxIcon,
      EditForm: ({ basePath }) => {
        return (
          <div className="grid grid-cols-2 gap-2">
            <StartDelayInput path={basePath.startDelaySec} />
          </div>
        );
      },
    },
  };

class EngineRpmMinViewModel extends ActionViewModel<EngineRpmMinViewModel> {
  constructor(
    effector: Effector,
    startInStageIndex: number,
    startDelaySec: number,
    public actionId: string,
    public actionData: SetEngineRpmToMin
  ) {
    super(effector, true, startInStageIndex, startDelaySec);
  }

  override toQuickAction(_finalActionThisEffector: boolean): QuickAction {
    return {
      actionId: uuidOrNewUuid(this.actionId),
      startDelay: secondsToDuration(this.startDelaySec),
      setEngineRpmToMin: this.actionData,
      carryOverIntoWorkTask: false,
    };
  }

  override actionCardTitle(
    t: TFunction,
    _rigEffectiveConfig: RigEffectiveConfig,
    stageIndex: number,
    _finalActionThisEffector: boolean
  ): string | undefined {
    if (stageIndex === this.startInStageIndex) {
      return t(
        "views.autotractor.autonomousActivities.action.cardTitle.engineMinRpm"
      );
    }
  }

  override effectorBlockedByActionMessage(t: TFunction): string {
    return t(
      "views.autotractor.autonomousActivities.action.blockingMessage.engineMinRpm"
    );
  }

  override components = engineRpmMin.components;
}
export const engineRpmMin: ActionViewModelImplementation<EngineRpmMinViewModel> =
  {
    actionButtonLabelI18nKey:
      "views.autotractor.autonomousActivities.action.buttonLabel.engineMinRpm",
    actionMenuSection: "holding-action",
    isNewActionAvailableForEffector: allEffectorsWithType("engine-rpm"),
    newAction: (effector, startInStageIndex) => {
      return new EngineRpmMinViewModel(effector, startInStageIndex, 0, "", {});
    },
    fromQuickAction: (action, startInStageIndex) => {
      if (action.setEngineRpmToMin) {
        return new EngineRpmMinViewModel(
          { type: "engine-rpm" },
          startInStageIndex,
          durationInSecondsOrZero(action.startDelay),
          action.actionId,
          action.setEngineRpmToMin
        );
      }
    },
    components: {
      Icon: DecreaseToMinIcon,
      EditForm: ({ basePath }) => {
        return (
          <div className="grid grid-cols-2 gap-2">
            <StartDelayInput path={basePath.startDelaySec} />
          </div>
        );
      },
    },
  };
